import script from "./AgentStepReviews.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentStepReviews.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import NumberStepper from "@/components/neue/wizard/NumberStepper.vue";
import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { NumberStepper, WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NumberStepper, WizardSection }, script.__o.components);}